/* What the activity feed calls each built-in knowledge file: a short noun phrase that finishes
   "Read about ___", shown in place of the file's path. Keyed by the path the knowledge tools take.
   Every file under projects/api/schema/pieve/knowledge/immutable needs an entry (see
   projects/api/schema/pieve/knowledge/AGENTS.md), and immutableKnowledgeLabels.test.js fails on a
   missing or stale one. The labels live here, not in the files, so they never reach the model. */
export const PIEVE_KNOWLEDGE_LABELS = Object.freeze({
  'immutable/apps/connection-knowledge.md': 'connection notes',
  'immutable/data/app-data-transforms.md': 'app data transforms',
  'immutable/data/large-data-tooling.md': 'working with large data',
  'immutable/data/stored-result-sets.md': 'stored result sets',
  'immutable/data/virtual-environment.md': 'the virtual environment',
  'immutable/onboarding/onboarding-checklist.template.md': 'the onboarding checklist',
  'immutable/onboarding/steps/apps-assessment.md': 'the apps assessment',
  'immutable/onboarding/steps/automation-brainstorming.md': 'automation brainstorming',
  'immutable/onboarding/steps/introduction.md': 'onboarding introductions',
  'immutable/onboarding/steps/schedules.md': 'schedules',
  'immutable/onboarding/steps/triggers.md': 'triggers',
  'immutable/skills/sharing.md': 'sharing skills',
  'immutable/skills/skill-format.md': 'the skill format',
  'immutable/tasks/mode-conversion.md': 'switching task modes',
  'immutable/tasks/sub-agents.md': 'sub-agents',
  'immutable/workflow/subjects/actions-needed.md': 'actions the user must take',
  'immutable/workflow/subjects/deterministic-vs-ai-step-split.md': 'AI and fixed workflow steps',
  'immutable/workflow/subjects/edge-case-apps.md': 'built-in apps',
  'immutable/workflow/subjects/environments.md': 'test and live environments',
  'immutable/workflow/subjects/failure-handling-and-alerts.md': 'failure handling and alerts',
  'immutable/workflow/subjects/vague-request-intake.md': 'vague requests',
  'immutable/workflow/workflow-building-checklist.template.md': 'the workflow building checklist',
  'immutable/workflow/workflow-types/data-syncing-workflows.md': 'data sync workflows',
  'immutable/workflow/workflow-types/general-workflows.md': 'general workflows',
  'immutable/workflow/workflows.md': 'building workflows'
});

export const getPieveKnowledgeLabel = (knowledgePath) => PIEVE_KNOWLEDGE_LABELS[knowledgePath] || null;
